;(function () {
    // IE11 swiper js 'startsWith' Polyfill
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }

    $('.fragrances .slider').each(function (index, el) {
        const $nextEl = el.querySelector('.swiper-button-next');
        const $prevEl = el.querySelector('.swiper-button-prev');

        var swiper = new Swiper(el, {
            allowTouchMove: false,
            a11y: {
                enabled: true,
                slideLabelMessage: ""
            },
            navigation: {
                nextEl: $nextEl,
                prevEl: $prevEl,
            },
        })
    
        var swiper = new Swiper(el.parentElement.querySelector('.slider-content'), {
            allowTouchMove: false,
            a11y: {
                enabled: true,
                slideLabelMessage: ""
            },
            navigation: {
                nextEl: $nextEl,
                prevEl: $prevEl,
            }
        })
    });

    var swiper = new Swiper('.item-image .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow:true,
        a11y: {
            enabled: true,
            slideLabelMessage: ""
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
})();
